import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'

/** Route name → required subuser permission slug(s). Prefer View/Access for page gates. */
export const ROUTE_PERMISSIONS: Record<string, string | string[]> = {
  // Menu setup
  'admin:my-menu': SUBUSER_PERMISSION_SLUGS.MENU_VIEW,
  'admin:bulk-menu': SUBUSER_PERMISSION_SLUGS.MENU_BULK_VIEW,
  'admin:pos-menu': SUBUSER_PERMISSION_SLUGS.MENU_VIEW,
  'admin:modifiers': SUBUSER_PERMISSION_SLUGS.MODIFIERS_VIEW,
  'admin:custom-inputs': SUBUSER_PERMISSION_SLUGS.CUSTOM_INPUTS_VIEW,
  'admin:cloud': SUBUSER_PERMISSION_SLUGS.MEDIA_VIEW,
  'admin:cloud-table': SUBUSER_PERMISSION_SLUGS.MEDIA_VIEW,
  'admin:taxes': [
    SUBUSER_PERMISSION_SLUGS.TAXES_VIEW,
    SUBUSER_PERMISSION_SLUGS.TAX_GROUPS_VIEW,
  ],

  // Users & roles
  'admin:users-wizard': SUBUSER_PERMISSION_SLUGS.SUBUSERS_VIEW,
  'admin:roles': SUBUSER_PERMISSION_SLUGS.ROLES_VIEW,

  // Publishing / general
  'admin:qr': SUBUSER_PERMISSION_SLUGS.GENERAL_QR_MANAGE,
  'admin:devices': SUBUSER_PERMISSION_SLUGS.GENERAL_DEVICES_VIEW,
  'admin:widget': SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
  'admin:domain': SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
  'admin:google-menu': SUBUSER_PERMISSION_SLUGS.MENU_VIEW,
  'admin:dynamic-links': SUBUSER_PERMISSION_SLUGS.GENERAL_QR_MANAGE,

  // Ordering setup
  'admin:services-wizard': SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
  'admin:payment-methods-wizard': SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
  'admin:vendor': SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
  'admin:opening-hours-wizard': SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,

  // Orders
  'admin:orders': SUBUSER_PERMISSION_SLUGS.ORDERS_VIEW,
  'admin:abandoned-orders': SUBUSER_PERMISSION_SLUGS.ORDERS_ABANDONED_VIEW,
  'admin:new-order': SUBUSER_PERMISSION_SLUGS.ORDERS_MANAGE,
  'admin:edit-order': SUBUSER_PERMISSION_SLUGS.ORDERS_MANAGE,
  'admin:return-orders': SUBUSER_PERMISSION_SLUGS.ORDERS_RETURN_ORDERS_VIEW,
  'admin:refunds': SUBUSER_PERMISSION_SLUGS.ORDERS_REFUND,
  'admin:orders-histories': SUBUSER_PERMISSION_SLUGS.ORDERS_VIEW,
  'admin:order-invoice': SUBUSER_PERMISSION_SLUGS.ORDERS_VIEW,

  // Reservations & queues
  'admin:reservations': SUBUSER_PERMISSION_SLUGS.RESERVATIONS_VIEW,
  'admin:product-reservations': SUBUSER_PERMISSION_SLUGS.ORDERS_RESERVATION_ORDERS_VIEW,
  'admin:queues': SUBUSER_PERMISSION_SLUGS.QUEUES_VIEW,

  // Kitchen / ODS
  'admin:kitchen': SUBUSER_PERMISSION_SLUGS.ORDER_DISPLAY_VIEW,

  // Transactions
  'admin:transactions': SUBUSER_PERMISSION_SLUGS.TRANSACTIONS_VIEW,

  // Dashboard — only general.statistics.view
  'admin:dashboard': SUBUSER_PERMISSION_SLUGS.GENERAL_STATISTICS_VIEW,

  // Statistics / auditor — do not include general.statistics.view (dashboard-only)
  'admin:statistics': SUBUSER_PERMISSION_SLUGS.REPORTS_STATISTICS_VIEW,
  'admin:branches-statistics': SUBUSER_PERMISSION_SLUGS.REPORTS_BRANCHES_STATISTICS_VIEW,

  // Integrations
  'admin:store': SUBUSER_PERMISSION_SLUGS.INTEGRATIONS_VIEW,
  'admin:integrations:view': SUBUSER_PERMISSION_SLUGS.INTEGRATIONS_VIEW,
  'admin:addons': SUBUSER_PERMISSION_SLUGS.INTEGRATIONS_VIEW,
  'admin:addons:view': SUBUSER_PERMISSION_SLUGS.INTEGRATIONS_VIEW,

  // CRM / clients
  'admin:customers': SUBUSER_PERMISSION_SLUGS.CLIENTS_VIEW,
  'admin:customers:items-insight': SUBUSER_PERMISSION_SLUGS.CLIENTS_VIEW,
  'admin:customers:statistics': SUBUSER_PERMISSION_SLUGS.CLIENTS_VIEW,
  'admin:customers:profile': SUBUSER_PERMISSION_SLUGS.CLIENTS_VIEW,
  'admin:customers:form': SUBUSER_PERMISSION_SLUGS.CLIENTS_MANAGE,
  'admin:customers:reviews': SUBUSER_PERMISSION_SLUGS.REVIEWS_VIEW,

  // Reports
  'admin:reports:gain-and-loss': SUBUSER_PERMISSION_SLUGS.REPORTS_GAIN_AND_LOSS_VIEW,
  'admin:reports:sales-per-category': SUBUSER_PERMISSION_SLUGS.REPORTS_SALES_PER_VIEW,
  'admin:reports:sales-per-item': SUBUSER_PERMISSION_SLUGS.REPORTS_SALES_PER_VIEW,
  'admin:reports:sales-per-delivery-area': SUBUSER_PERMISSION_SLUGS.REPORTS_SALES_PER_VIEW,
  'admin:reports:sales-per': SUBUSER_PERMISSION_SLUGS.REPORTS_SALES_PER_VIEW,
  'admin:reports:order-lines': SUBUSER_PERMISSION_SLUGS.REPORTS_ORDER_LINES_VIEW,
  'admin:reports:order-details': SUBUSER_PERMISSION_SLUGS.REPORTS_ORDERS_VIEW,
  'admin:reports:transferable-orders': SUBUSER_PERMISSION_SLUGS.REPORTS_TRANSFERABLE_ORDERS_VIEW,
  'admin:reports:custom-report': SUBUSER_PERMISSION_SLUGS.REPORTS_SALES_VIEW,
  'admin:reports:self-compare': SUBUSER_PERMISSION_SLUGS.REPORTS_STATISTICS_VIEW,

  // Inventory
  'admin:inventory:units': SUBUSER_PERMISSION_SLUGS.INVENTORY_UNITS_VIEW,
  'admin:inventory:suppliers': SUBUSER_PERMISSION_SLUGS.INVENTORY_SUPPLIERS_VIEW,
  'admin:inventory:suppliers-process': SUBUSER_PERMISSION_SLUGS.INVENTORY_SUPPLIERS_MANAGE,
  'admin:inventory:recipes': SUBUSER_PERMISSION_SLUGS.INVENTORY_RECIPES_VIEW,
  'admin:inventory:ingredients': SUBUSER_PERMISSION_SLUGS.INVENTORY_INGREDIENTS_VIEW,
  'admin:inventory:report': SUBUSER_PERMISSION_SLUGS.INVENTORY_STOCK_REPORT_VIEW,
  'admin:inventory:transactions': SUBUSER_PERMISSION_SLUGS.INVENTORY_TRANSACTIONS_VIEW,
  'admin:inventory:transactions:type': SUBUSER_PERMISSION_SLUGS.INVENTORY_TRANSACTIONS_VIEW,
  'admin:inventory:branches': SUBUSER_PERMISSION_SLUGS.INVENTORY_STOCK_VIEW,
  'admin:inventory:spot-check': SUBUSER_PERMISSION_SLUGS.INVENTORY_SPOT_CHECKS_VIEW,
  'admin:inventory:spot-check:process': SUBUSER_PERMISSION_SLUGS.INVENTORY_SPOT_CHECKS_VIEW,
  'admin:inventory:inventory-count': SUBUSER_PERMISSION_SLUGS.INVENTORY_COUNTS_VIEW,
  'admin:inventory:inventory-count:process': SUBUSER_PERMISSION_SLUGS.INVENTORY_COUNTS_VIEW,

  // POS
  'admin:pos:preview': SUBUSER_PERMISSION_SLUGS.POS_PREVIEW_VIEW,
  'admin:pos:terminals': SUBUSER_PERMISSION_SLUGS.POS_TERMINALS_VIEW,
  'admin:pos:sessions': SUBUSER_PERMISSION_SLUGS.POS_SESSIONS_VIEW,
  'admin:pos:settings': [
    SUBUSER_PERMISSION_SLUGS.POS_SETTINGS_VIEW,
    SUBUSER_PERMISSION_SLUGS.POS_PAYMENT_METHODS_VIEW,
    SUBUSER_PERMISSION_SLUGS.POS_RETURN_REASONS_VIEW,
  ],

  // Marketing
  'admin:surveys': SUBUSER_PERMISSION_SLUGS.SURVEYS_VIEW,
  'admin:surveys:form': SUBUSER_PERMISSION_SLUGS.SURVEYS_VIEW,
  'admin:surveys:statistics': SUBUSER_PERMISSION_SLUGS.SURVEYS_VIEW,
  'admin:coupons': SUBUSER_PERMISSION_SLUGS.COUPONS_VIEW,
  'admin:promotions': SUBUSER_PERMISSION_SLUGS.PROMOTIONS_VIEW,
  'admin:marketing-events': SUBUSER_PERMISSION_SLUGS.MARKETING_EVENTS_VIEW,
  'admin:campaigns': SUBUSER_PERMISSION_SLUGS.CAMPAIGNS_VIEW,
  'admin:discounts': SUBUSER_PERMISSION_SLUGS.DISCOUNTS_VIEW,
  'admin:wallet-packages': SUBUSER_PERMISSION_SLUGS.WALLETS_MANAGE,
  'admin:newsletters': SUBUSER_PERMISSION_SLUGS.NEWSLETTERS_VIEW,
  'admin:newsletters:form': SUBUSER_PERMISSION_SLUGS.NEWSLETTERS_VIEW,
  'admin:banners': SUBUSER_PERMISSION_SLUGS.BANNERS_VIEW,
  'admin:wp-campaigns': SUBUSER_PERMISSION_SLUGS.CAMPAIGNS_VIEW,
  'admin:abandoned-carts': SUBUSER_PERMISSION_SLUGS.CLIENTS_VIEW,

  // Mobile notifications
  'admin:mobile:notifications': SUBUSER_PERMISSION_SLUGS.NOTIFICATIONS_VIEW,

  // Payment links / branches / settings
  'admin:payment-links': SUBUSER_PERMISSION_SLUGS.PAYMENT_LINKS_VIEW,
  'admin:settings': [
    SUBUSER_PERMISSION_SLUGS.SETTINGS_BUSINESS_INFO_VIEW,
    SUBUSER_PERMISSION_SLUGS.SETTINGS_BUSINESS_SETTINGS_VIEW,
    SUBUSER_PERMISSION_SLUGS.SETTINGS_SOCIAL_LINKS_VIEW,
    SUBUSER_PERMISSION_SLUGS.SETTINGS_WHATSAPP_REPORTS_VIEW,
    SUBUSER_PERMISSION_SLUGS.SETTINGS_EMAIL_REPORTS_VIEW,
    SUBUSER_PERMISSION_SLUGS.SETTINGS_POLICIES_VIEW,
    SUBUSER_PERMISSION_SLUGS.SETTINGS_TIERS_VIEW,
    SUBUSER_PERMISSION_SLUGS.SETTINGS_TAGS_VIEW,
    SUBUSER_PERMISSION_SLUGS.SETTINGS_AGE_GROUPS_VIEW,
    SUBUSER_PERMISSION_SLUGS.SETTINGS_ACCESS,
    SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
  ],
  'admin:branches-management': [
    SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
    SUBUSER_PERMISSION_SLUGS.BRANCHES_MANAGE,
    SUBUSER_PERMISSION_SLUGS.BRANCHES_RECEIPT_MANAGE,
  ],
  'admin:display-devices': SUBUSER_PERMISSION_SLUGS.DISPLAY_DEVICES_VIEW,

  // Design
  'admin:design:qr': SUBUSER_PERMISSION_SLUGS.SETTINGS_THEMES_MANAGE,
  'admin:design:qr:form': SUBUSER_PERMISSION_SLUGS.SETTINGS_THEMES_MANAGE,
  'admin:design:tablet': SUBUSER_PERMISSION_SLUGS.SETTINGS_THEMES_MANAGE,
  'admin:design:tablet:form': SUBUSER_PERMISSION_SLUGS.SETTINGS_THEMES_MANAGE,
  'admin:design:receipt-setting': [
    SUBUSER_PERMISSION_SLUGS.BRANCHES_RECEIPT_MANAGE,
    SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
  ],
  'admin:design:mobile': SUBUSER_PERMISSION_SLUGS.SETTINGS_THEMES_MANAGE,
  'admin:design:mobile:form': SUBUSER_PERMISSION_SLUGS.SETTINGS_THEMES_MANAGE,

  // Logs
  'admin:logs:transferred-orders': SUBUSER_PERMISSION_SLUGS.ORDERS_TRANSFER_EXECUTE,
}

export function getRoutePermission(routeName?: string | null): string | string[] | null {
  if (!routeName) return null
  return ROUTE_PERMISSIONS[routeName] ?? null
}

export default ROUTE_PERMISSIONS
